module.exports = __webpack_public_path__ + "assets/fdf9274df775ff6b93f5c5b7bf4d5c65.png";